import CustomerBonusService from '../../services/CustomerBonusService';
import customerBonusUseCase from './customerBonusUseCase';

const customerBonusFactory = customerBonusUseCase({
  CustomerBonusService: CustomerBonusService(),
});

export default customerBonusFactory;
